import { createContext } from 'react';
import { AuthContextState } from './types';

export const AuthContext = createContext<AuthContextState>(null);
